import { DepositCryptoOption } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';

interface InfoTextProps {
  setIsInfoOpened: (open: boolean) => void;
  selectedCryptoMethod?: DepositCryptoOption;
}

export const InfoText = ({ setIsInfoOpened, selectedCryptoMethod }: InfoTextProps) => {
  const { t } = useTranslation();

  const minAmountToDisplay = parseFloat(selectedCryptoMethod?.min_amount || '0');

  const amountAndCurrency = selectedCryptoMethod
    ? `${minAmountToDisplay} ${selectedCryptoMethod?.name}`
    : '';

  return (
    <div className="text-xs text-wdap_nodapay_method_text">
      <ol className="list-decimal pl-4">
        <li>{t('depositCryptochill.ruleFirst')}</li>
        <li>{t('depositCryptochill.ruleSecond')}</li>
        <li key={amountAndCurrency}>
          {t('depositCryptochill.ruleThird', {
            amountAndCurrency
          })}
        </li>
        <li>{t('depositCryptochill.ruleFourth')}</li>
        <li>
          <button
            className="text-wdap_min_deposit_amount underline"
            onClick={() => setIsInfoOpened(true)}>
            {t('depositCryptochill.moreInfo')}
          </button>
        </li>
      </ol>
    </div>
  );
};
